module.exports = __webpack_public_path__ + "static/media/step-3.17b73034.png";